import { ClientInvoiceData } from "../bank";
import { IConverter, TSnapshot } from "./generics";

export const invoiceConverter: IConverter<ClientInvoiceData> = {
  toFirestore(invoice: ClientInvoiceData) {
    return invoice;
  },
  fromFirestore(snapshot: TSnapshot): ClientInvoiceData {
    const data = snapshot.data();
    if (!data) {
      throw new Error("Invoice data is undefined");
    }
    return {
      id: snapshot.id,
      clientId: data.clientId,
      projectId: data.projectId,
      status: data.status,
      dueDate: data.dueDate,
      csaId: data.csaId,
      invoiceNumber: data.invoiceNumber,
      invoiceDate: data.invoiceDate,
      billTo: data.billTo,
      shipTo: data.shipTo,
      items: data.items,
      terms: data.terms,
      discount: data.discount,
      totalDollarAmountDue: data.totalDollarAmountDue,
      pdfUrl: data.pdfUrl,
      stakeholderPaymentIds: data.stakeholderPaymentIds,
      cardPaymentsAllowed: data.cardPaymentsAllowed,
      cardPaymentFeeWaived: data.cardPaymentFeeWaived,
      partialPaymentAmount: data.partialPaymentAmount,
    };
  },
};
